import { getOwaUrlWithAddedQueryParameters } from './getOwaUrlWithAddedQueryParameters';

export default function getTaskItemReadDeepLinkUrl(itemId: string): string {
    let popoutQuerystringProps = {
        viewmodel: 'TaskReadingPaneViewModelPopOutFactory',
        ItemID: encodeURIComponent(itemId),
        ispopout: '1',
    };

    // VSO 36661: Get deeplink URL for task into To-Do module when user is opted into ReactTasks
    return getOwaUrlWithAddedQueryParameters(popoutQuerystringProps);
}
